import { render, staticRenderFns } from "./invitationsidebarNew.vue?vue&type=template&id=4108f9ea"
import script from "./invitationsidebarNew.vue?vue&type=script&lang=ts"
export * from "./invitationsidebarNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4108f9ea')) {
      api.createRecord('4108f9ea', component.options)
    } else {
      api.reload('4108f9ea', component.options)
    }
    module.hot.accept("./invitationsidebarNew.vue?vue&type=template&id=4108f9ea", function () {
      api.rerender('4108f9ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/companyContractors/invitationsidebarNew.vue"
export default component.exports